import { render, staticRenderFns } from "./persona.vue?vue&type=template&id=1f700a60"
import script from "./persona.vue?vue&type=script&lang=js"
export * from "./persona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports